// routes
import { PATH_DASHBOARD } from './routes/paths';

// VARIABLES & API
// ----------------------------------------------------------------------

export const SERVER_API = {
  server: "$SERVER_API",
};

export const RAINBOW_VAR = {
  host: "$RAINBOW_HOST",
  appId: "$RAINBOW_APP_ID",
  appOAuthRedirectUri: "$REACT_APP_OAUTH_REDIRECT_URI",
  waOAuthRedirectUri: "$REACT_APP_WA_OAUTH_REDIRECT_URI",
  sentryDsn: "$SENTRY_DSN_ADMIN",
  sentryEnv: "$SENTRY_ENV"
};

// export const SERVER_API = {
//   server: process.env.REACT_APP_SERVER_API
// }

// export const RAINBOW_VAR = {
//   host: process.env.REACT_APP_RAINBOW_HOST,
//   appId: process.env.REACT_APP_RAINBOW_APP_ID,
//   appOAuthRedirectUri: process.env.REACT_APP_OAUTH_REDIRECT_URI,
//   waOAuthRedirectUri: process.env.REACT_APP_WA_OAUTH_REDIRECT_URI,
//   sentryDsn: process.env.REACT_APP_SENTRY_DSN,
//   sentryEnv: process.env.REACT_APP_SENTRY_ENV
// };

export const PATH_AFTER_LOGIN = PATH_DASHBOARD.general.analytics; // as '/main'

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 92,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
};

export const NAV = {
  W_BASE: 260,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
};

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};
